import { route } from 'react-router-typesafe-routes/dom';
export const ROUTES = {
    MAIN: route(''),
    FUNDS: route('repository', {}, {
        MEDIA: route('media', {}, {
            SEARCH_RESULT: route('search-result'),
            SUB_CATEGORY: route('sub-category'),
            CATEGORY_CONTENT: route('category-content'),
        }),
        BOOKS: route('books', {}, { BOOK_COVER: route('book-cover') }),
        CONTACTS: route('contacts'),
    }),
    LOGIN: route('login'),
};
